import { FC } from 'react';
import { Field, FieldProps } from 'formik';
import { Toggle } from './Toggle';

interface UserBooleanInputProps {
  name: string;
  title?: string;
  description?: string;
  callback?: (value: boolean) => void;
}

export const UserBooleanInput: FC<UserBooleanInputProps> = ({ name, title, description, callback }) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps<boolean>) => (
        <div className="w-full">
          <div className="text-sm font-bold text-text-dark">{title}</div>
          <div className="flex flex-row items-center overflow-hidden rounded-lg min-h-16">
            <div className="pr-8 text-sm font-medium text-text-dark">{description}</div>
            <div className="ml-auto">
              <Toggle
                checked={field.value}
                onChange={() => {
                  form.setFieldValue(name, !field.value);
                  if (callback) {
                    callback(!field.value);
                  }
                }}
                onBlur={() => form.setTouched({ ...form.touched, [field.name]: true }, true)}
              />
            </div>
          </div>
        </div>
      )}
    </Field>
  );
};
